// extracted by mini-css-extract-plugin
export default {"alert-title":"Grbas_alert-title__AI2MQ","alert-prompt":"Grbas_alert-prompt__1ZhN8","error-msg":"Grbas_error-msg__UO4A-"};